
import request from '../utils/request'
const { ocpSaasPath } = window.globalConfig;
export default class RoleApi {
  /**
   * 查询角色
   * @param params
   * @returns {*|Promise<*>}
   */
  static query = (params) => {
    return request.post(`/${ocpSaasPath}/api/0/role/queryRoleByPage`, params)
  }
  /**
   * 创建角色
   * @param params
   * @returns {*|Promise<*>}
   */
  static create = (params, config) => {
    return request.post(`/${ocpSaasPath}/api/0/role/create`, params, config)
  }
  /**
   * 删除角色
   * @param params
   * @returns {*|Promise<*>}
   */
  static delete = (params) => {
    return request.post(`/${ocpSaasPath}/api/0/role/delete`, params)
  }
  /**
 * 更新角色
 * @param params
 * @returns {*|Promise<*>}
 */
  static update = (params) => {
    return request.post(`/${ocpSaasPath}/api/0/role/update`, params)
  }
  /**
   * 根据角色查询角色对应的资源
   * @param params
   * @returns {*|Promise<*>}
   */
  static queryRoleResource = (params) => {
    return request.post(`/${ocpSaasPath}/api/0/role/queryRoleResource`, params)
  }
  /**
   * 查询角色的所有用户
   * @param params
   * @returns {*|Promise<*>}
   */
  static queryRoleUserByIds = (params) => {
    return request.post(`/${ocpSaasPath}/api/0/role/queryRoleUserByIds`, params)
  }
  /**
   * 角色查询
   * @param params
   * @returns {*|Promise<*>}
   */
  static queryRoles = (params) => {
    return request.post(`/${ocpSaasPath}/api/0/role/queryRoles`, params)
  }
  /**
   * 分配角色资源
   * @param params
   * @returns {*|Promise<*>}
   */
  static awarded = (params) => {
    return request.post(`/ocp-saas/api/0/role/awardedRoleResource`, params)
  }

  /**
   * 根绝角色标识符查询角色的所有用户
   * @param params
   * @returns {*|Promise<*>}
   */
  static queryRoleUserByIdentifier = (params) => {
    return request.post(`/ocp-saas/api/0/role/queryUserByStationRoleAndIdentifier`, params)
  }
  /**
   * 字典表
   */
   static getDictByType = (params) => {
    return request.appid(`/${ocpSaasPath}/api/0/dictData/getDictByType?dictType=${params}`)
  }
  /**
   * 字典类型表
   */
   static getDictType = (params) => {
    return request.appid(`/${ocpSaasPath}/api/0/dictType/getDictType?dictGroup=${params}`)
  }
  /**
   * 查询场站角色
   */
   static roleByStand = (params) => {
    return request.post(`/ocp-saas/api/0/role/list?stationId=${params.stationId}`)
  }
  /**
   * 查询场站人员
   */
   static userByStand = (params) => {
    return request.appid(`/ocp-saas/api/0/user/getRoleUserByStationId?stationId=${params.stationId}`)
  }

  /**
   * 查询场站人员详情
   */
   static getRoleInfoById = (params) => {
    return request.post(`/ocp-saas/api/0/role/getRoleInfoById?roleId=${params.roleId}`,params)
  }
}
